import { eduIDApi } from "./common";
export const letterProofingApi = eduIDApi.injectEndpoints({
    endpoints: (builder) => ({
        letterProofingState: builder.query({
            query: () => ({
                url: "proofing",
            }),
            extraOptions: { service: "letterProofing" },
        }),
        requestLetter: builder.query({
            query: (body) => ({
                url: "proofing",
                body,
            }),
            extraOptions: { service: "letterProofing" },
        }),
        confirmLetterCode: builder.query({
            query: (body) => ({
                url: "verify-code",
                body,
            }),
            extraOptions: { service: "letterProofing" },
        }),
    }),
});
